export default __webpack_public_path__ + "static/media/biogas-icon.2c6481db.svg";